import script from "./OpalPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpalPill.vue?vue&type=script&setup=true&lang=ts"

import "./OpalPill.vue?vue&type=style&index=0&id=7ec44fe7&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec44fe7"]])

export default __exports__